import { HandlerType, StatusType } from "@datadog/browser-logs";
import { DefaultEnv } from "../store/env";

const { dataDogToken } = DefaultEnv;

const LogHandlers = {
  development: HandlerType.console,
  production: HandlerType.http,
  test: HandlerType.console
};

const LogLevels = {
  development: StatusType.info,
  production: StatusType.warn,
  test: StatusType.warn
};

let handler: HandlerType =
  LogHandlers[process.env.NODE_ENV] || HandlerType.console;
const level: StatusType = LogLevels[process.env.NODE_ENV] || StatusType.error;

if (!dataDogToken) {
  handler = HandlerType.console;
}

export const LoggerOptions = {
  handler,
  level
};
